<div class="acr-modal" *transloco="let t; prefix: 'compliance.library.addRequirementsModal'">
  <div class="acr-modal__header">
    <span>{{ t('title') }}</span>
    <button type="button" class="acr-modal__close" (click)="cancel()" [attr.aria-label]="'common.close' | transloco">
      <i class="ph ph-x"></i>
    </button>
  </div>

  <div class="acr-modal__body">
    <div class="acr-modal__field">
      <label class="acr-modal__field-label">{{ t('checklistType') }}</label>
      <div ngbDropdown class="acr-modal__dropdown" container="body">
        <button type="button" class="acr-modal__dropdown-toggle"
          [class.acr-modal__dropdown-toggle--placeholder]="checklistTypeId === null"
          ngbDropdownToggle>
          <span>{{ checklistTypeLabel }}</span>
          <i class="ph ph-caret-down"></i>
        </button>
        <div ngbDropdownMenu class="acr-modal__dropdown-menu">
          @for (type of checklistTypes; track type.id) {
            <button type="button" ngbDropdownItem (click)="selectChecklistType(type.id)">{{ checklistTypeName(type.id) }}</button>
          }
        </div>
      </div>
    </div>

    <div class="acr-modal__field">
      <label class="acr-modal__field-label">{{ t('categoryNameLabel') }}</label>
      <input type="text" class="acr-modal__text" name="acrNewCategory"
        [(ngModel)]="newCategoryName" [placeholder]="t('categoryNamePlaceholder')" maxlength="200"
        (input)="validateCategoryName()" />
      @if (categoryError) {
        <span class="acr-modal__field-error">{{ categoryError }}</span>
      }
    </div>

    <div class="acr-modal__field">
      <label class="acr-modal__field-label">{{ t('addRequirements') }}</label>

      @for (req of requirements; let i = $index; track i) {
        <div class="requirement-row">
          <input class="acr-modal__text requirement-row__input" type="text"
            [(ngModel)]="req.name" [placeholder]="t('requirementNamePlaceholder')">

          <label class="requirement-row__critical" (click)="$event.stopPropagation()">
            <input type="checkbox" [(ngModel)]="req.critical">
            <span>{{ t('critical') }}</span>
          </label>

          @if (!isInspectionChecklistSelected) {
            <button type="button" class="icon-btn" (click)="openLinkDocumentTypeModal(req)" [title]="t('linkDocumentType')">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M5.64383 7.52871C6.39917 6.77338 7.7165 6.77338 8.47183 7.52871L8.94317 8.00004L9.88583 7.05738L9.4145 6.58604C8.78583 5.95671 7.9485 5.60938 7.05783 5.60938C6.16717 5.60938 5.32983 5.95671 4.70117 6.58604L3.2865 8.00004C1.98783 9.29938 1.98783 11.4147 3.2865 12.714C3.9365 13.364 4.78983 13.6887 5.64317 13.6887C6.49717 13.6887 7.35117 13.364 8.0005 12.714L8.47183 12.2427L7.52917 11.3L7.05783 11.7714C6.27783 12.5494 5.00917 12.5507 4.22917 11.7714C3.44983 10.9914 3.44983 9.72271 4.22917 8.94271L5.64383 7.52871Z" fill="#EE2737"/>
                <path d="M7.99861 3.28725L7.52728 3.75858L8.46995 4.70125L8.94128 4.22992C9.72061 3.45192 10.9893 3.45058 11.7699 4.22992C12.5493 5.00992 12.5493 6.27858 11.7699 7.05858L10.3553 8.47258C9.59995 9.22792 8.28261 9.22792 7.52728 8.47258L7.05595 8.00125L6.11328 8.94392L6.58461 9.41525C7.21328 10.0446 8.05061 10.3919 8.94128 10.3919C9.83195 10.3919 10.6693 10.0446 11.2979 9.41525L12.7126 8.00125C14.0113 6.70192 14.0113 4.58658 12.7126 3.28725C11.4126 1.98725 9.29728 1.98792 7.99861 3.28725Z" fill="#EE2737"/>
              </svg>
            </button>
          }

          <button type="button" class="icon-btn" (click)="removeRequirement(i)" [title]="t('deleteRequirement')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3.33724 13.332C3.33724 14.0674 3.93524 14.6654 4.67057 14.6654H11.3372C12.0726 14.6654 12.6706 14.0674 12.6706 13.332V5.33203H14.0039V3.9987H12.0039H11.3372V2.66536C11.3372 1.93003 10.7392 1.33203 10.0039 1.33203H6.00391C5.26857 1.33203 4.67057 1.93003 4.67057 2.66536V3.9987H4.00391H2.00391V5.33203H3.33724V13.332ZM6.00391 2.66536H10.0039V3.9987H6.00391V2.66536ZM5.33724 5.33203H10.6706H11.3372L11.3379 13.332H4.67057V5.33203H5.33724Z" fill="#EE2737"/>
              <path d="M6.00391 6.66797H7.33724V12.0013H6.00391V6.66797ZM8.67057 6.66797H10.0039V12.0013H8.67057V6.66797Z" fill="#EE2737"/>
            </svg>
          </button>
        </div>

        @if (req.documentTypeId !== null) {
          <span class="type-pill">
            {{ req.documentTypeName }}
            <button type="button" class="type-pill__remove" (click)="confirmUnlinkDocumentType(req)" [title]="t('unlinkDocumentType')">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M10.7946 4.23047L7.96598 7.05847L5.13798 4.23047L4.19531 5.17314L7.02331 8.00114L4.19531 10.8291L5.13798 11.7718L7.96598 8.9438L10.7946 11.7718L11.7373 10.8291L8.90931 8.00114L11.7373 5.17314L10.7946 4.23047Z" fill="#9FA1A4"/>
              </svg>
            </button>
          </span>
        }
      }

      <button type="button" class="add-requirement-btn" (click)="addRequirement()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M14.3214 7.41692L8.3067 4.08358C8.10603 3.97225 7.86203 3.97225 7.66137 4.08292L1.67603 7.38958C1.46403 7.50692 1.3327 7.72958 1.33203 7.97225C1.33137 8.21492 1.46203 8.43758 1.67403 8.55558L7.6887 11.9156C7.79003 11.9722 7.90137 12.0003 8.01337 12.0003C8.12537 12.0003 8.2367 11.9723 8.33737 11.9163L14.3227 8.58292C14.5347 8.46492 14.6654 8.24158 14.6654 7.99958C14.6654 7.75758 14.534 7.53425 14.3214 7.41692ZM8.01403 10.5702L3.37137 7.97692L7.9827 5.42892L12.6254 8.00158L8.01403 10.5702Z" fill="#EE2737"/>
          <path d="M7.99978 14.6654C8.11111 14.6654 8.22311 14.6374 8.32311 14.5814L14.3231 11.248L13.6758 10.0827L7.99978 13.236L2.32311 10.0827L1.67578 11.248L7.67578 14.5814C7.77645 14.6374 7.88845 14.6654 7.99978 14.6654ZM13.3331 1.33203H11.9998V2.66536H10.6664V3.9987H11.9998V5.33203H13.3331V3.9987H14.6664V2.66536H13.3331V1.33203Z" fill="#EE2737"/>
        </svg>
        <span>{{ t('addRequirement') }}</span>
      </button>
    </div>
  </div>

  <div class="acr-modal__footer">
    <button type="button" class="acr-modal__btn-cancel" (click)="cancel()" [disabled]="isSaving">{{ 'common.cancel' | transloco }}</button>
    <button type="button" class="acr-modal__btn-save" (click)="saveAsync()" [disabled]="isSaveDisabled">
      @if (isSaving) {
        <span class="spinner-border spinner-border-sm"></span>
      } @else {
        <span>{{ t('save') }}</span>
      }
    </button>
  </div>
</div>
